import React from 'react';
import { useStyles } from './styles';
import {InputV2, ButtonV2, Typography, Box, Link} from '@/elements';
import { Error } from '@mui/icons-material';
import AuthWrapper from '../../components/global/Wrappers/authWrapper';
import { useNavigate } from 'react-router-dom';
import routes from '../../routes';
import { Controller, useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import { RESET_PASSWORD } from '../../actions/update';
import { useMutation } from '@apollo/client';
import { toast } from 'react-toastify';
import { InputAdornment } from "@mui/material";

const ForgotPassword = () => {
  const classes = useStyles();

  const navigate = useNavigate();

  const [resPass, { loading }] = useMutation(RESET_PASSWORD, {
    fetchPolicy: 'no-cache',
    context: {
      plug: true,
    },
  });
  const onSubmit = (data) => {
    resPass({
      variables: {
        email: data.email,
        type: 'PARTNER_ACCOUNT_EMPLOYEE',
      },
    })
      .then(() => {
        toast.success('Success');
        navigate(`${routes.resetPasswordDone}?email=${data.email}`);
      })
      .catch((err) => console.log(err.message));
  };

  const validationSchema = Yup.object().shape({
    email: Yup.string().required('This field is required').email('Email address must be valid'),
  });

  const {
    handleSubmit,
    formState: { errors },
    control,
  } = useForm({
    resolver: yupResolver(validationSchema),
  });

  return (
    <>
      <AuthWrapper>
        <Box justify="center" align="center" direction="column" gap="20px" width="100%">
          <Typography variant="h6">
            Reset password
          </Typography>
          <Typography variant={"subtitle1"}>
            Enter the email address and we will send you a link to reset your password.
          </Typography>
          <Box justify="center" direction="column" gap="40px" width="100%">
            <form className={classes.form} onSubmit={handleSubmit(onSubmit)}>
              <Controller
                name="email"
                control={control}
                defaultValue=""
                render={({ field: { onChange, value } }) => (
                  <InputV2
                    onChange={onChange}
                    value={value}
                    label="Email"
                    width="100%"
                    isError={Boolean(errors.email)}
                    placeholder={'username@example.com'}
                    helperText={errors?.email?.message}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          {errors.email ? <Error color="error" /> : ''}
                        </InputAdornment>
                      ),
                    }}
                  />
                )}
              />
              <ButtonV2 type="submit" width="100%" size="big">
                reset password
              </ButtonV2>
              <Link to={routes.auth}>
                Return to log in
              </Link>
            </form>
          </Box>
        </Box>
      </AuthWrapper>
    </>
  );
};

export default ForgotPassword;
